import { ApiError } from '@/lib/api';

/**
 * The server's own explanation for a rejected submission, when it gave one.
 *
 * Worth surfacing verbatim: a refused review is refused for a specific,
 * actionable reason — an unapproved Gate 1, a senior-only contract, a decision
 * already recorded — and a generic "failed to record" tells the reviewer none
 * of them.
 */
export function serverDetail(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  const detail = err.body?.detail;
  return typeof detail === 'string' && detail.trim() ? detail : null;
}
